import styles from './teams-overlay.module.css'
import closeImg from '../../assets/gfx/close.svg'
import teams from '../../data/teams'

import leaderImg from '../../assets/teams/Leader.svg';
import { Fragment } from 'react/jsx-runtime';

function TeamsOverlay({ close }) {
    return <div className={styles.wrapper}>
        <img width="128" onClick={close} src={closeImg} alt="close" className={styles.close} />
        <div className={styles.inner}>
            <div className={styles.title}>TEAMS</div>
            {Object.keys(teams).map((shownTeam) => (
                <Fragment key={shownTeam}>
                    <div className={styles['team-name']}>
                        {shownTeam}
                    </div>
                    <div className={styles['team-cards']} >
                        <a rel="noreferrer" target="_blank" href={teams[shownTeam].leader.url} className={[styles['team-image-container']].join(" ")}>
                            <img src={teams[shownTeam].leader.img} className={styles['team-image-image']} alt={teams[shownTeam].leader.name} />
                            <div style={{fontFamily: (teams[shownTeam].altFont || teams[shownTeam].leader.altFont) ? 'impact' : 'kuramubon'}} className={styles['team-image-text']}>{teams[shownTeam].leader.name}</div>
                            <img className={styles['team-leader-image']} src={leaderImg} alt="leader" width="50%" />
                        </a>
                        <a rel="noreferrer" target="_blank" href={teams[shownTeam].member[0].url} className={[styles['team-image-container']].join(" ")}>
                            <img src={teams[shownTeam].member[0].img} className={styles['team-image-image']} alt={teams[shownTeam].member[0].name} />
                            <div style={{fontFamily: (teams[shownTeam].altFont || teams[shownTeam].member[0].altFont) ? 'impact' : 'kuramubon'}} className={styles['team-image-text']}>{teams[shownTeam].member[0].name}</div>
                        </a>
                        <a rel="noreferrer" target="_blank" href={teams[shownTeam].member[1].url} className={[styles['team-image-container'], teams[shownTeam].member[1].name === 'パンの耳' ? styles['team-image-container-pantsu'] : ''].join(" ")}>
                            <img src={teams[shownTeam].member[1].img} className={styles['team-image-image']} alt={teams[shownTeam].member[1].name} />
                            <div style={{fontFamily: (teams[shownTeam].altFont || teams[shownTeam].member[1].altFont) ? 'impact' : 'kuramubon'}} className={styles['team-image-text']}>{teams[shownTeam].member[1].name}</div>
                        </a>
                        <a rel="noreferrer" target="_blank" href={teams[shownTeam].member[2].url} className={[styles['team-image-container']].join(" ")}>
                            <img src={teams[shownTeam].member[2].img} className={styles['team-image-image']} alt={teams[shownTeam].member[2].name} />
                            <div style={{fontFamily: (teams[shownTeam].altFont || teams[shownTeam].member[2].altFont) ? 'impact' : 'kuramubon'}} className={styles['team-image-text']}>{teams[shownTeam].member[2].name}</div>
                        </a>
                    </div>
                </Fragment>
            ))}
        </div>
    </div>;
}

export default TeamsOverlay;